// import React from 'react';
import i18next from 'i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import RegisterStep1Screen from './containers/RegisterStep1ScreenContainer';
import RegisterStep2Screen from './components/RegisterStep2Screen';
import RegisterStep3Screen from './components/RegisterStep3Screen';
import RegisterStep4Screen from './components/RegisterStep4Screen';

// const RegisterStep1Screen = React.lazy(() => import('./containers/RegisterStep1ScreenContainer'));
// const RegisterStep2Screen = React.lazy(() => import('./components/RegisterStep2Screen'));

const register = () => {
  Logger.log('debug', `register.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'register', 'routes'])) {
    Events.dispatch(
      'ADD_DEFAULT_ROUTES',

      // screen name (key): [route type (element), path (prop), exact (prop), component (prop)]
      {
        RegisterStep1Screen: [
          'Route',
          '/register',
          true,
          RegisterStep1Screen,
          i18next.t('register_route_step1'),
        ],
        RegisterStep2Screen: [
          'Route',
          '/register/step2',
          true,
          RegisterStep2Screen,
          i18next.t('register_route_step2'),
        ],
        RegisterStep3Screen: [
          'PrivateRoute',
          '/register/step3',
          true,
          RegisterStep3Screen,
          i18next.t('register_route_step3'),
        ],
        RegisterStep4Screen: [
          'PrivateRoute',
          '/register/step4',
          true,
          RegisterStep4Screen,
          i18next.t('register_route_step4'),
        ],
      }
    );
  }
};

export default register;

Logger.log('silly', `register.register() loaded.`);
